import Reveal from "./Reveal";
import { IMG_TWO_FARMERS, IMG_UREA_GLOVE, IMG_FARMER_RUN, IMG_FARMER_FIELD } from "./assets";

const cards = [
  { icon: "fa-shield-halved", title: "Zero Fraud Guarantee", desc: "Cryptographic QR + AI anomaly engine make black-market diversion mathematically impossible." },
  { icon: "fa-bolt", title: "2ms QR Response", desc: "Sub-frame scan-to-status latency, edge-cached across 9 regional PoPs nationwide." },
  { icon: "fa-hand-holding-heart", title: "Farmer-First Design", desc: "Big buttons, low-data forms, voice prompts. Built in collaboration with FPO field officers." },
  { icon: "fa-cloud", title: "99.9% Uptime SLA", desc: "Multi-AZ failover with hot-standby DB. The dashboard never blinks, even during peak Rabi rush." },
  { icon: "fa-eye", title: "Real-time Visibility", desc: "District commissioners see every bag scanned in their jurisdiction within 5 seconds of the event." },
  { icon: "fa-certificate", title: "GS1 Compliant", desc: "Codes follow GS1-128 global standard — interoperable with any retail POS or warehouse scanner." },
];

const photos = [IMG_TWO_FARMERS, IMG_UREA_GLOVE, IMG_FARMER_RUN, IMG_FARMER_FIELD];

export default function WhyChooseUs() {
  return (
    <section className="section why" id="why" data-testid="why-section">
      <div className="section-inner">
        <div className="why-header">
          <Reveal>
            <span className="section-eyebrow">Why Choose Fertilizer Tracking</span>
            <h2 className="section-heading">
              Trusted by Fertilizer Companies. <em>Loved</em> by farmers.
            </h2>
            <p className="section-desc">
              Six pillars that make Fertilizer Tracking the most resilient fertiliser-tracking
              system deployed at national scale.
            </p>
          </Reveal>
        </div>

        <div className="why-grid">
          {cards.map((c, i) => (
            <Reveal key={c.title} delay={i * 70}>
              <div className="why-card" data-testid={`why-card-${i}`}>
                <div className="icon">
                  <i className={`fa-solid ${c.icon}`}></i>
                </div>
                <h3>{c.title}</h3>
                <p>{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="photo-collage">
            {photos.map((src, i) => (
              <div key={i} className="photo-tile">
                <img src={src} alt={`Fertilizer Tracking field operation ${i + 1}`} />
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
